import { Button } from '@/src/shadComponents/ui/button';

type FlowTemplates = FlowTemplate[];
type FlowTemplate = {
    name: string;
    definition: any;
};

const Romr_3_2 = {
    name: 'ROMR 3:2',
    definition: [
        {
            name: 'resize',
            arguments: {
                in: 'input file',
                out: 'output file',
                width: '',
                height: '',
                totalPixels: '2160000',
            },
            fileType: 'jpg',
            fileCount: 1,
            saveOutput: true,
            argumentTypes: {
                width: 'number',
                height: 'number',
                totalPixels: 'number',
            },
        },
        {
            name: 'sbcolor',
            arguments: {
                in: 'input file',
                out: 'output file',
            },
            fileType: 'jpg',
            fileCount: 1,
            saveOutput: true,
        },
        {
            name: 'overlay',
            arguments: {
                in: 'input file',
                out: 'output file',
                overlay: 'overlay file 1',
                aspectRatio: '0.66',
            },
            fileType: 'jpg',
            fileCount: 1,
            saveOutput: true,
            argumentTypes: {
                overlay: 'fileurl',
                aspectRatio: 'aspectConditional',
            },
        },
        {
            name: 'overlay',
            arguments: {
                in: 'input file',
                out: 'output file',
                overlay: 'overlay file 2',
                aspectRatio: '1.5',
            },
            fileType: 'jpg',
            fileCount: 1,
            saveOutput: true,
            argumentTypes: {
                overlay: 'fileurl',
                aspectRatio: 'aspectConditional',
            },
        },
    ],
};

const Romr_16_9 = {
    name: 'ROMR 16:9',
    definition: [
        {
            name: 'resize',
            arguments: {
                in: 'input file',
                out: 'output file',
                width: '',
                height: '',
                totalPixels: '2073600',
            },
            fileType: 'jpg',
            fileCount: 1,
            saveOutput: true,
            argumentTypes: {
                width: 'number',
                height: 'number',
                totalPixels: 'number',
            },
        },
        {
            name: 'sbcolor',
            arguments: {
                in: 'input file',
                out: 'output file',
            },
            fileType: 'jpg',
            fileCount: 1,
            saveOutput: true,
        },
        {
            name: 'overlay',
            arguments: {
                in: 'input file',
                out: 'output file',
                overlay: 'overlay file 1',
                aspectRatio: '0.56',
            },
            fileType: 'jpg',
            fileCount: 1,
            saveOutput: true,
            argumentTypes: {
                overlay: 'fileurl',
                aspectRatio: 'aspectConditional',
            },
        },
        {
            name: 'overlay',
            arguments: {
                in: 'input file',
                out: 'output file',
                overlay: 'overlay file 2',
                aspectRatio: '1.77',
            },
            fileType: 'jpg',
            fileCount: 1,
            saveOutput: true,
            argumentTypes: {
                overlay: 'fileurl',
                aspectRatio: 'aspectConditional',
            },
        },
    ],
};

const flowTemplates: FlowTemplates = [Romr_3_2, Romr_16_9];

export default function FlowTemplatePicker({ onSelect, onClose }: any) {
    return (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
            <div className="bg-background rounded-lg shadow-lg p-6 space-y-4 min-w-[300px]">
                {flowTemplates.map((template) => {
                    return (
                        <div
                            className="p-3 border border-border rounded-md cursor-pointer hover:bg-accent transition-colors"
                            onClick={() => onSelect(template.definition)}
                            key={template.name}
                        >
                            {template.name}
                        </div>
                    );
                })}
                <div className="flex-1" />
                <div className="flex justify-end">
                    <Button onClick={onClose} variant="outline">
                        Close
                    </Button>
                </div>
            </div>
        </div>
    );
}
